/**
 * Rankings Section JavaScript
 * Handles profile toggle functionality and interactive elements
 */

class RankingsSection {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.setupAccessibility();
  }

  bindEvents() {
    // Handle profile toggle clicks - also listen for clicks on the entire ranking block
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-profile-toggle]');
      const rankingBlock = e.target.closest('.ranking-block');
      
      if (toggle) {
        e.preventDefault();
        this.toggleProfile(toggle);
      } else if (rankingBlock && !e.target.closest('.ranking-action')) {
        // Allow clicking anywhere on the block except action buttons
        const blockToggle = rankingBlock.querySelector('[data-profile-toggle]');
        if (blockToggle) {
          e.preventDefault();
          this.toggleProfile(blockToggle);
        }
      }
    });

    // Handle keyboard navigation
    document.addEventListener('keydown', (e) => {
      const toggle = e.target.closest('[data-profile-toggle]');
      if (toggle && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        this.toggleProfile(toggle);
      }
    });
  }

  toggleProfile(toggle) {
    console.log('Toggle profile clicked');
    const rankingBlock = toggle.closest('.ranking-block');
    const content = rankingBlock.querySelector('[data-profile-content]');
    const arrow = toggle.querySelector('.ranking-arrow');
    
    if (!rankingBlock || !content) {
      console.log('Missing ranking block or content');
      return;
    }

    const isExpanded = rankingBlock.classList.contains('expanded');
    console.log('Is expanded:', isExpanded);
    
    if (isExpanded) {
      this.closeProfile(rankingBlock, content, toggle);
    } else {
      this.openProfile(rankingBlock, content, toggle);
    }
  }

  openProfile(rankingBlock, content, toggle) {
    // Add expanded class
    rankingBlock.classList.add('expanded');
    
    // Update ARIA attributes
    toggle.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    
    // Update toggle text (optional)
    const label = toggle.querySelector('.ranking-label');
    if (label) {
      label.textContent = 'CLOSE';
    }

    // Smooth scroll to profile if needed
    setTimeout(() => {
      this.scrollToProfile(rankingBlock);
    }, 100);

    // Trigger custom event
    this.dispatchCustomEvent('rankingProfileOpened', {
      block: rankingBlock,
      profileId: rankingBlock.dataset.profileId
    });
  }

  closeProfile(rankingBlock, content, toggle) {
    // Remove expanded class
    rankingBlock.classList.remove('expanded');
    
    // Update ARIA attributes
    toggle.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    
    // Update toggle text
    const label = toggle.querySelector('.ranking-label');
    if (label) {
      label.textContent = 'PROFILE';
    }

    // Trigger custom event
    this.dispatchCustomEvent('rankingProfileClosed', {
      block: rankingBlock,
      profileId: rankingBlock.dataset.profileId
    });
  }

  closeOtherProfiles(currentToggle) {
    const currentBlock = currentToggle.closest('.ranking-block');
    const allBlocks = document.querySelectorAll('.ranking-block.expanded');
    
    allBlocks.forEach(block => {
      if (block !== currentBlock) {
        const toggle = block.querySelector('[data-profile-toggle]');
        const content = block.querySelector('[data-profile-content]');
        if (toggle && content) {
          this.closeProfile(block, content, toggle);
        }
      }
    });
  }

  scrollToProfile(rankingBlock) {
    const headerOffset = 100; // Adjust based on your header height
    const elementPosition = rankingBlock.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  setupAccessibility() {
    // Set up initial ARIA attributes
    const toggles = document.querySelectorAll('[data-profile-toggle]');
    const contents = document.querySelectorAll('[data-profile-content]');
    
    toggles.forEach((toggle, index) => {
      const rankingBlock = toggle.closest('.ranking-block');
      const content = rankingBlock.querySelector('[data-profile-content]');
      
      if (content) {
        const contentId = `ranking-content-${index}`;
        content.id = contentId;
        toggle.setAttribute('aria-controls', contentId);
        toggle.setAttribute('aria-expanded', 'false');
        content.setAttribute('aria-hidden', 'true');
      }
      
      // Make toggle focusable
      if (!toggle.hasAttribute('tabindex')) {
        toggle.setAttribute('tabindex', '0');
      }
    });
  }

  dispatchCustomEvent(eventName, detail) {
    const event = new CustomEvent(eventName, {
      detail: detail,
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(event);
  }

  // Public method to open a specific profile by ID
  openProfileById(profileId) {
    const block = document.querySelector(`[data-profile-id="${profileId}"]`);
    if (block) {
      const toggle = block.querySelector('[data-profile-toggle]');
      if (toggle) {
        this.toggleProfile(toggle);
      }
    }
  }

  // Public method to close all profiles
  closeAllProfiles() {
    const expandedBlocks = document.querySelectorAll('.ranking-block.expanded');
    expandedBlocks.forEach(block => {
      const toggle = block.querySelector('[data-profile-toggle]');
      const content = block.querySelector('[data-profile-content]');
      if (toggle && content) {
        this.closeProfile(block, content, toggle);
      }
    });
  }
}

// Initialize the rankings section
function initRankingsSection() {
  if (!window.rankingsSection) {
    window.rankingsSection = new RankingsSection();
    console.log('Rankings section initialized');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRankingsSection);
} else {
  initRankingsSection();
}
